import React from 'react';
import { Link, useLocation } from 'react-router-dom';
export default function StockTransferDistributionBreadCrumbs() {
  const location = useLocation();
  const vPathName = location.pathname;
  return (
    <div className="container-fluid p-0 breadcrumb">
      <div>
        <span className="breadcrumb-arrow-inactive">Stock Transfer Distribution Summary</span>
      </div>
      {/* {vPathName === '/StockTransferDistribution' ? (
        <div>
          <span className="breadcrumb-arrow-inactive">Stock Transfer Distribution Summary</span>
        </div>
      ) : vPathName === '' ? (
        <div className="d-flex">
          <Link
            to="/StockTransferDistribution"
            state={location}
            className={'breadcrumb-arrow-active mr-2'}>
            Stock Transfer Distribution Summary
          </Link>
          <div>
            <span className="breadcrumb-arrow-inactive">Stock Transfer Distribution Detail</span>
          </div>
        </div>
      ) : (
        <></>
      )} */}
    </div>
  );
}
